import { Injectable } from '@angular/core';
import { LoginResponseModel } from '../modules/login/models/loginResponseModel';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { PermissionService } from 'src/app/services/permission.service';
//import { RestAPIService } from './restapi.service';

@Injectable({
    providedIn: 'root'
  })
  export class AuthService {
    private apiUrl = environment.apiURL;
    constructor(private http: HttpClient, private permissions: PermissionService) {}

    getAccessToken() {
      return localStorage.getItem('access_token');
    }
  
    getRefreshToken() {
      return localStorage.getItem('refresh_token');
    }

    refreshToken(): Observable<any> {
      let postData = {
        accessToken: this.getAccessToken(),
        refreshToken: this.getRefreshToken()
      };
      //this._restAPI.post<any>(`${this.apiUrl}api/user/refreshtoken`,postData,false);
      return this.http.post<any>(`${this.apiUrl}api/user/refreshtoken`,  postData);
    }

    saveTokens(access: string, refresh: string) {
      localStorage.setItem('access_token', access);
      localStorage.setItem('refresh_token', refresh);
    }

    isAuthenticated(): boolean {
      const token = this.getAccessToken();
      // Simple check: token exists (could add expiry check here)
      return !!token;
    }
    logout(): void {
      localStorage.removeItem('access_token');
      localStorage.removeItem('refresh_token');
      localStorage.removeItem('token_data');
      this.permissions.clearPermissions();
    }

    login(loginresponse: LoginResponseModel): void {
      if(loginresponse.authenticationResult?.accessToken && loginresponse.authenticationResult?.refreshToken) {
        this.saveTokens(loginresponse.authenticationResult.accessToken, loginresponse.authenticationResult.refreshToken);
      }
      if(loginresponse.claims) {
        this.permissions.setPermissions(loginresponse.claims);
      }
      localStorage.setItem('token_data',JSON.stringify(loginresponse));
    }
  }